import { z } from "zod";

const config = {
  globalFeatureFlags: (
    import.meta.env.VITE_APP_GLOBAL_FEATURE_FLAGS || ""
  ).split(","),
  api: {
    graphqlApiUri: import.meta.env.VITE_APP_GRAPHQL_API_URI,
    authApiUri: import.meta.env.VITE_APP_AUTH_API_URI,
    restApiUri: import.meta.env.VITE_APP_REST_API_URI,
  },
  sentry: {
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    env: import.meta.env.VITE_APP_SENTRY_ENV,
  },
  intercomAppId: import.meta.env.VITE_APP_INTERCOM_APP_ID,
  postHog: {
    projectKey: import.meta.env.VITE_APP_POSTHOG_KEY,
    apiHost: import.meta.env.VITE_APP_POSTHOG_API_HOST,
    uiHost: import.meta.env.VITE_APP_POSTHOG_UI_HOST,
  },
};

const schema = z.object({
  globalFeatureFlags: z.array(z.string()),
  api: z.object({
    graphqlApiUri: z.url(),
    authApiUri: z.url(),
    restApiUri: z.url(),
  }),
  sentry: z.object({
    dsn: z.string().nullish(),
    env: z.string().nullish(),
  }),
  intercomAppId: z.string().nullish(),
  postHog: z.object({
    projectKey: z.string().nullish(),
    apiHost: z.url().default("https://eu.i.posthog.com"),
    uiHost: z.url().default("https://eu.posthog.com"),
  }),
});

const result = schema.safeParse(config);

if (!result.success) {
  const keys = result.error.issues.map(({ path }) => path.join("."));
  throw new Error(`Missing env keys: ${JSON.stringify(keys, null, 2)}`);
}

const envConfig: z.infer<typeof schema> = result.data;

export default envConfig;
